import React, { Component } from 'react';
import { Button, Input, Checkbox, message, Popconfirm, Table, Modal } from 'antd';
import CpSearchBar from '../../components/CpSearchBar';
import CpLogo from '../../components/CpLogo';
import CpEmpty from '../../components/CpEmpty';
import CpLoading from '../../components/CpLoading';
import { enquiryListSelect, enquiryListDelete, enquiryListSave } from './api';
import { EnquiryCartProduct } from './components/enquiryCartProduct';
import { inventoryCategoryList } from '../proposal/api';
import './style.less';

const { localStorage } = window;
const maxNumber = 999999999;

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAll: false, // 全选按钮
      emptyStatus: 'enquiryCart',
      loading: true,
      list: [],
      selectedRowKeys: [], // 勾选完清空数据
      selectedRows: [], // 勾选完清空数据
      categoryList: [],
      productModalVisible: false,
    };
  }

  componentDidMount() {
    this.initCart();
    this.getInventoryCategoryList();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  async initCart() {
    try {
      const { data: { data: { list = [] }, msg, code } } = await enquiryListSelect();
      if (+code === 0) {
        this.setState({ list, selectedAll: false });
      } else {
        message.error(msg);
      }
    } finally {
      this.setState({ loading: false });
    }
  }

  submitPlanOrder = () => {
    this.submit(2);
  }

  submitOrder = () => {
    this.submit('enquiryCart');
  }

  submit = (type) => {
    const { selectedRows = [] } = this.state;
    if (selectedRows.length <= 0) {
      message.info('请先选择商品');
      return;
    }

    localStorage.setItem('orderData', JSON.stringify(selectedRows));
    this.props.history.push('/basic/enquirySubmit/?type=' + type);
  }

  baseUpdate = (list = []) => {
    return new Promise(async (resolve, reject) => {
      const { data: { code, msg } } = await enquiryListSave({ data: list });
      resolve({ code, msg });
    });
  }
  add = async (record) => {
    const { id, sale_number } = record;
    const { list = [] } = this.state;
    let number = +sale_number + 1;
    if (number > maxNumber) {
      number = maxNumber;
      this.setState({ list: list.map(item => (item.id === id ? { ...item, sale_number: number } : item)) });
    } else {
      const { code, msg } = await this.baseUpdate([{ ...record, sale_number: number }]);
      if (+code === 0) {
        this.setState({ list: list.map(item => (item.id === id ? { ...item, sale_number: number } : item)) });
      } else {
        message.error(msg);
      }
    }
  }

  reduce = async (record) => {
    const { sale_number, id } = record;
    const { list = [] } = this.state;
    const number = +sale_number - 1;
    if (number < 1) {
      message.info('商品数量不能再减少了');
    } else {
      const { code, msg } = await this.baseUpdate([{ ...record, sale_number: number }]);
      if (+code === 0) {
        this.setState({ list: list.map(item => (item.id === id ? { ...item, sale_number: number } : item)) });
      } else {
        message.error(msg);
      }
    }
  }

  inputChanged = (e, { id }) => {
    const { target: { value } } = e;
    const sale_number = Number(value.replace(/\D/g, '')) || '';
    const { list = [] } = this.state;
    this.setState({ list: list.map(item => (item.id === id ? { ...item, sale_number } : item)) });
  }

  onBlur = async (e, record) => {
    const { id, sale_number } = record;
    const { list = [] } = this.state;
    let number = +sale_number;
    if (number < 1) {
      message.info('商品数量不能少于1');
      number = 1;
      this.setState({ list: list.map(item => (item.id === id ? { ...item, sale_number: number } : item)) });
    } else if (number > maxNumber) {
      number = maxNumber;
      this.setState({ list: list.map(item => (item.id === id ? { ...item, sale_number: number } : item)) });
    } else {
      const { code, msg } = await this.baseUpdate([record]);
      if (+code === 0) {
        this.setState({ list: list.map(item => (item.id === id ? { ...item, sale_number: number } : item)) });
      } else {
        message.error(msg);
      }
    }
  }

  removeProduct = async ({ id }) => {
    const { data: { code, msg } } = await enquiryListDelete({ id: [id] });
    const { list = [] } = this.state;
    if (+code === 0) {
      // message.success(msg, () => this.setState({ list: list.filter(item => item.id !== id) }));
      this.setState({ list: list.filter(item => item.id !== id) });
    } else {
      message.error(msg);
    }
  }

  removeProducts = async () => {
    const { selectedRowKeys = [], list = [] } = this.state;
    if (selectedRowKeys.length) {
      const { data: { code, msg } } = await enquiryListDelete({ id: selectedRowKeys });
      if (+code === 0) {
        // message.success(msg, () => this.initCart());
        this.setState({ list: list.filter(item => !selectedRowKeys.includes(item.id)), selectedRows: [], selectedRowKeys: [] });
      } else {
        message.error(msg);
      }
    }
  }
  selectedAllAction = (e) => {
    const { target: { checked } } = e;
    const { list = [] } = this.state;
    if (checked) {
      this.setState({ selectedRows: list, selectedRowKeys: list.map(item => item.id), selectedAll: checked });
    } else {
      this.setState({ selectedRows: [], selectedRowKeys: [], selectedAll: checked });
    }
  }
  searchTypeChanged = (value) => {
    this.setState({
      searchType: value
    });
  }

  searchValueChanged = (value) => {
    this.setState({
      searchValue: value
    });
  }
  openProductModal = () => {
    this.setState({ productModalVisible: true });
  }
  closeProductModal = () => {
    this.setState({ productModalVisible: false });
  }
  refresh = () => {
    this.initCart();
    this.closeProductModal();
  }
  async getInventoryCategoryList() {
    const { data: { code, msg, data } } = await inventoryCategoryList();
    if (+code === 0) {
      this.setState({ categoryList: data });
    } else {
      message.error(msg);
    }
  }
  render() {
    const { fixedBottom = true, selectedAll, emptyStatus, loading, searchValue = '', searchType = '1', list = [], selectedRowKeys = [], productModalVisible = false, categoryList = [] } = this.state;
    const header = (
      <div className="shop-cart-top">
        <CpLogo />
        <div style={{ marginLeft: '40px' }}>
          <CpSearchBar
            searchValue={searchValue}
            searchType={searchType}
            searchValueChanged={this.searchValueChanged}
            searchTypeChanged={this.searchTypeChanged} />
        </div>
      </div>
    );

    const empty = (<div className="cart-empty"><CpEmpty status={emptyStatus} history={this.props.history} action={this.openProductModal} /></div>);
    const chooseCheck = {
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({
          selectedAll: selectedRowKeys.length === list.length,
          selectedRowKeys,
          selectedRows
        });
      },
    };
    const columns = [
      {
        dataIndex: 'selectState',
        title: '全选',
      },
      {
        dataIndex: 'product',
        title: '商品信息',
        align: 'left',
        render: (_, record) => {
          return <>
            <div>{record?.sku_name}</div>
            <div>规格:{record?.sale_norms}</div>
          </>;
        }
      },
      {
        dataIndex: 'sale_number',
        title: '数量',
        align: 'center',
        width: 300,
        render: (_, record) => {
          return <div className="countContainer">
            <span className="btn pointer" onClick={() => { this.reduce(record); }}>-</span>
            <Input className="input" defaultValue={+_} value={+record.sale_number} onChange={(e) => { this.inputChanged(e, record); }} onBlur={(e) => { this.onBlur(e, record); }} onPressEnter={(e) => { this.onBlur(e, record); }} />
            <span className="btn pointer" onClick={() => { this.add(record); }}>+</span>
          </div>;
        }
      },
      {
        dataIndex: 'action',
        title: '操作',
        align: 'center',
        width: 200,
        render: (_, record) => {
          return <Popconfirm
            title="确定要删除商品吗?"
            onConfirm={() => this.removeProduct(record)}
            okText="确认"
            cancelText="取消"
          >
            <span className='pointer'>删除</span>
            {/* //  <Typography.Link onClick={() => this.removeProduct(record)}>删除</Typography.Link>; */}
          </Popconfirm>;
        }
      },
    ];

    return (
      <>
        <div className="shop-cart">
          {header}
          {list.length ? <div className='action-bar'><Button type='primary' onClick={this.openProductModal}>添加商品</Button></div> : null}
          {list.length === 0 ? empty :
            <div className="shop-cart-content">
              {loading ? <CpLoading className="cp-loading" /> : null}
              <div className="shop-cart-list enquiry-cart-table">
                <Table
                  columns={columns}
                  dataSource={list}
                  pagination={false}
                  rowSelection={chooseCheck}
                  rowKey='id'
                >

                </Table>
              </div>
              {
                fixedBottom && (<div className="whitespace"></div>)
              }
              {
                list.length <= 0 ? null :
                  <div className={fixedBottom ? 'bottom fixed-bottom' : 'bottom'}>
                    <div className="bottom-content">
                      <div className="bottom-left">
                        <div className="bottom-select-all"><Checkbox style={{ margin: '0px 12px' }} checked={selectedAll} onChange={(e) => { this.selectedAllAction(e); }}></Checkbox>全选</div>
                        <div className="bottom-delete-select">
                          <span className='pointer' onClick={() => { this.removeProducts(); }}>删除所选商品</span>
                        </div>
                      </div>
                      <div className="bottom-right">
                        <div className="bottom-select-count">已选择<span className="bottom-select-count-value">{selectedRowKeys?.length}</span>件商品</div>
                        {/* <div className="bottom-select-price">总价：<span className="bottom-select-price-value">￥{totalPrice}</span></div> */}
                        {/* <Button className="bottom-submit-plan" onClick={this.submitPlanOrder}>提交计划单</Button> */}
                        <Button className="bottom-submit-settlement" onClick={this.submitOrder}>提交询价单</Button>
                      </div>
                    </div>
                  </div>
              }
            </div>
          }

        </div>
        <Modal title='商品列表' open={productModalVisible} destroyOnClose width={1200} centered onCancel={this.closeProductModal} getContainer={false} footer={false} >
          <EnquiryCartProduct {...{ categoryList, refresh: this.refresh, type: 'enquiryCart' }} />
        </Modal>
      </>
    );
  }
}

export default Cart;
